import { data } from '../../svg/Dangerous/data';
import { makeIcon } from '../makeIcon';

export const Dangerous = makeIcon(data, 'dangerous', 'Dangerous');

export default Dangerous;
